<script setup lang="ts">
import { UiDialog, UiText, UiIcon } from '@shopexperts/shared';
import { useRouter } from 'vue-router';
import UpgradeBanner from './UpgradeBanner.vue';

const model = defineModel<boolean>({ default: false });
const router = useRouter();

function onCompleteYourListing() {
  model.value = false;
  router.push('/expert/listing');
}
</script>

<template>
  <UiDialog 
    v-model="model" 
    title="**Congratulations!**
You're now an official shopexperts member."
    size="lg"
    primary-action-label="Complete Your Listing"
    :arrows-on-action-buttons="true"
    @primary-action="onCompleteYourListing"
  >
    <div class="flex flex-col gap-8">
      <UiText 
        as="p" 
        variant="p" 
        text="Set up your profile so clients can easily discover you and see what makes your work stand out. The more complete your profile, the better your chances of getting quality leads."
        class="text-se-gray-700"
      />

      <div class="flex flex-col gap-6">
        <div class="flex items-center gap-4">
          <UiIcon name="image" class="w-6 h-6 text-se-gray-600 flex-shrink-0" />
          <UiText 
            as="p" 
            variant="p" 
            class="text-se-gray-900"
          >
          Upload a high-quality <span class="font-semibold">profile image</span> and write a <span class="font-semibold">short bio</span>.
        </UiText>
        </div>

        <div class="flex items-center gap-4">
          <UiIcon name="marker-pin" class="w-6 h-6 text-se-gray-600 flex-shrink-0" />
          <UiText 
            as="p" 
            variant="p" 
            class="text-se-gray-900"
          >
          Select your <span class="font-semibold">main services</span> to show what you offer.
        </UiText>
        </div>

        <div class="flex items-center gap-4">
          <UiIcon name="package-placeholder" class="w-6 h-6 text-se-gray-600 flex-shrink-0" />
          <UiText 
            as="p" 
            variant="p" 
            class="text-se-gray-900"
          >
          Create your first <span class="font-semibold">packaged service</span> for easy booking.
        </UiText>
        </div>

        <div class="flex items-center gap-4">
          <UiIcon name="image-placeholder" class="w-6 h-6 text-se-gray-600 flex-shrink-0" />
          <UiText 
            as="p" 
            variant="p" 
            class="text-se-gray-900"
          >
          Share <span class="font-semibold">case studies</span> that highlight your results.
        </UiText>
        </div>

        <div class="flex items-center gap-4">
          <UiIcon name="file-placeholder" class="w-6 h-6 text-se-gray-600 flex-shrink-0 mt-1" />
          <UiText 
            as="p" 
            variant="p" 
            class="text-se-gray-900"
          >
          Add answers to common <span class="font-semibold">FAQs</span> to build trust with clients.
        </UiText>
        </div>
      </div>

      <UpgradeBanner />
    </div>

    <!--
    <template #actions>
      <div class="text-center flex justify-center mt-2">
        <UiText as="span" variant="p" class="text-se-gray-600">
            Have questions?
        </UiText>
        <UiLink 
          href="mailto:hello@shopexperts.com" 
          label="Send us an email." 
          external="subtle"
          variant="p"
          class="text-se-highlight underline"
        />
      </div>
    </template>
    -->
  </UiDialog>
</template>
